/* TWHEELS Blog-Tabellen mobil (03.11.2026): Tabellen mit Kopfzeile und mindestens drei Spalten
   werden unter 750 px als Karten gezeigt. Jede Zelle bekommt ihre Spaltenueberschrift als data-label,
   die CSS in assets/custom.css (.tw-rte-table--stack) blendet sie vor dem Wert ein. */
(function () {
  function headerCells(table) {
    var head = table.querySelector('thead tr');
    if (head) return { row: head, cells: head.querySelectorAll('th, td') };
    var first = table.querySelector('tr');
    if (!first) return null;
    var cells = first.querySelectorAll('th, td');
    if (!cells.length || first.querySelectorAll('td').length) return null;
    return { row: first, cells: cells };
  }
  function prepare(root) {
    root.querySelectorAll('table').forEach(function (table) {
      if (table.dataset.twTable) return;
      var head = headerCells(table);
      if (!head) return;
      var labels = Array.prototype.map.call(head.cells, function (c) { return c.textContent.replace(/\s+/g, ' ').trim(); });
      table.dataset.twTable = labels.length >= 3 ? 'stack' : 'pair';
      if (labels.length < 3) return;
      table.classList.add('tw-rte-table--stack');
      head.row.classList.add('tw-rte-table__head');
      table.querySelectorAll('tr').forEach(function (row) {
        if (row === head.row) return;
        Array.prototype.forEach.call(row.children, function (cell, i) {
          if (labels[i]) cell.setAttribute('data-label', labels[i]);
          // Reine Nummern-Spalte (z.B. «1», «2a»): als «Schritt 1» statt einsamer Ziffer zeigen.
          if (i === 0 && labels[0] && cell.textContent.trim().length <= 3) cell.classList.add('tw-rte-table__num');
        });
      });
    });
  }
  function run() { document.querySelectorAll('.content-blog').forEach(prepare); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
